import * as React from 'react';
import '../../../Box/index.js';
import { Icon } from '../../../Icon/Icon.js';
import { Image as ImageMemoized } from '../../../Image/Image.js';
import { useImageAsset } from './useImageAsset.js';
import { Box } from '../../../Box/Box.js';

var AssetElementView = function AssetElementView(_ref) {
  var asset = _ref.asset,
    disabled = _ref.disabled,
    textColor = _ref.textColor,
    opacity = _ref.opacity,
    ariaSelected = _ref['aria-selected'];
  var _useImageAsset = useImageAsset({
      asset: asset,
      disabled: disabled,
      textColor: textColor
    }),
    isImage = _useImageAsset.isImage,
    defaultHeightWidthValue = _useImageAsset.defaultHeightWidthValue,
    heightNumber = _useImageAsset.heightNumber,
    borderRadius = _useImageAsset.borderRadius,
    applyOpacityToContainer = _useImageAsset.applyOpacityToContainer;
  if (isImage(asset)) {
    var _asset$image$alt;
    return /*#__PURE__*/React.createElement(ImageMemoized, {
      src: asset.image.src,
      alt: (_asset$image$alt = asset.image.alt) !== null && _asset$image$alt !== void 0 ? _asset$image$alt : '' // to make it decorative
      ,
      objectFit: asset.scale === 'fit' ? 'contain' : 'cover',
      loading: "lazy",
      disabled: disabled,
      responsive: "manual",
      width: defaultHeightWidthValue,
      height: defaultHeightWidthValue,
      requestWidth: heightNumber,
      borderRadius: borderRadius
    });
  }
  var iconElement = /*#__PURE__*/React.createElement(Icon, {
    id: asset.id,
    size: asset.size || '24',
    color: textColor,
    opacity: applyOpacityToContainer ? undefined : opacity,
    "aria-selected": ariaSelected
  });
  return applyOpacityToContainer ? /*#__PURE__*/React.createElement(Box, {
    as: "span",
    display: "inline-flex",
    opacity: opacity
  }, iconElement) : iconElement;
};
var ImageAsset = /*#__PURE__*/React.memo(AssetElementView);

export { ImageAsset };
//# sourceMappingURL=ImageAsset.js.map
